import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import Button from '@mui/material/Button';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { isConfigFlagEnabled } from '../config';
import { addMessageBox } from '../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../redux/store';
import { assertUnreachable } from '../utils/tsUtils';
import { isTestEnvironment } from '../utils/utils';
export const ContactUsButton = ({ target, isLoggedIn, variant, fullWidth, closeDrawer }) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const openContactUsSubPage = useCallback(() => {
        // Cypress can't easily test links that open in a new tab.
        // If logged in, we want to load the page in a new window to avoid disrupting any game that may be in progress.
        const isOpeningInNewTab = isTestEnvironment() ? false : isLoggedIn;
        if (isOpeningInNewTab) {
            window.open('./contact', '_blank');
        }
        else {
            navigate('contact');
        }
    }, [isLoggedIn, navigate]);
    const onClick = useCallback(() => {
        closeDrawer?.();
        switch (target) {
            case 'modal': {
                if (isConfigFlagEnabled('contactUsModal')) {
                    dispatch(addMessageBox({ type: 'contact-us' }));
                }
                else {
                    // contact us modal is not enabled, fall back to sub-page
                    openContactUsSubPage();
                }
                break;
            }
            case 'sub-page': {
                openContactUsSubPage();
                break;
            }
            default: {
                assertUnreachable(target);
            }
        }
    }, [closeDrawer, dispatch, openContactUsSubPage, target]);
    return (_jsx(Button, { onClick: onClick, startIcon: _jsx(EmailRoundedIcon, {}), variant: variant, size: 'small', fullWidth: fullWidth, children: "Contact Us" }));
};
